module.exports = __webpack_public_path__ + "static/media/logo.8f381000.png";